/* Strange Quartz Stone Edition: carousel section.
   One script for the local preview and the Shopify section. No dependencies.

   Each slide has a position: 0 is the card in the middle, -1 / +1 the cards
   peeking at the edges, and anything further sits hidden off screen. A move:
   1. the middle card's words slide down out of sight,
   2. every card glides one place, the backdrop cross-fades to the new stone,
   3. the new middle card's words slide up into place. */
(function () {
  'use strict';
  // the theme editor can run this file again when it re-renders the section
  if (window.StrangeStoneCarousel) { window.StrangeStoneCarousel.init(); return; }

  var TEXT_OUT = 260;     // ms the words get before the cards start to move
  var GLIDE = 1050;       // keep equal to --ssc-glide in the css
  var TEXT_IN_EARLY = 260;// ms before the glide ends that the new words start

  function Carousel(root) {
    this.root = root;
    this.stage = root.querySelector('[data-ssc-stage]');
    this.track = root.querySelector('.ssc__track');
    this.live = root.querySelector('[data-ssc-live]');
    this.cta = root.querySelector('[data-ssc-cta]');
    this.cursor = root.querySelector('[data-ssc-cursor]');
    this.bgs = [].slice.call(root.querySelectorAll('[data-ssc-bg]'));
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.timers = [];
    this.queue = [];
    this.busy = false;

    var real = [].slice.call(root.querySelectorAll('[data-ssc-slide]'));
    this.count = real.length;
    if (!this.count) return;
    // with fewer than 4 stones there is no spare card to bring in from the far side: copy the set
    var slides = real.slice();
    if (this.count > 1 && this.count < 4) {
      var copies = Math.ceil(4 / this.count) - 1;
      for (var c = 0; c < copies; c++) {
        real.forEach(function (s) {
          var k = s.cloneNode(true);
          k.setAttribute('data-ssc-clone', '');
          k.removeAttribute('aria-label');
          k.removeAttribute('role');
          k.removeAttribute('aria-roledescription');
          this.track.appendChild(k);
          slides.push(k);
        }, this);
      }
    }
    this.slides = slides;
    this.n = slides.length;
    this.cur = 0;
    this.pos = slides.map(function (_, i) { return this.wrap(i); }, this);

    this.band = root.getAttribute('data-band') || 'strap';
    if (this.count < 2) root.classList.add('is-single');

    this.place(true);
    this.show(0, true);
    slides[0].classList.add('is-shown');
    this.setBand(this.band, true);
    this.bindControls();
    this.bindDrag();
    this.bindCursor();
    this.bindAutoplay();
    root.classList.add('is-ready');
    this.warm();
  }

  // decode every watch picture once the page is idle, so no card stalls when it first comes in
  Carousel.prototype.warm = function () {
    var imgs = [].slice.call(this.root.querySelectorAll('.ssc__img'));
    var go = function () {
      imgs.forEach(function (im) {
        im.loading = 'eager';
        if (im.decode) im.decode().catch(function () {});
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200);
  };

  Carousel.prototype.wrap = function (d) {
    var n = this.n;
    d = ((d % n) + n) % n;
    if (d > n / 2) d -= n;
    return d;               // for 4 slides: -1, 0, 1, 2
  };

  Carousel.prototype.later = function (fn, ms) {
    var t = setTimeout(fn, ms);
    this.timers.push(t);
    return t;
  };

  // write every slide's position to the page
  Carousel.prototype.place = function (instant) {
    this.slides.forEach(function (s, i) {
      var p = this.pos[i];
      if (instant) s.classList.add('no-anim');
      s.style.setProperty('--off', p);
      s.classList.toggle('is-center', p === 0);
      s.classList.toggle('is-side', Math.abs(p) === 1);
      s.classList.toggle('is-far', Math.abs(p) > 1);
      var hidden = p !== 0;
      if (hidden) s.setAttribute('aria-hidden', 'true'); else s.removeAttribute('aria-hidden');
      if (s.hasAttribute('data-ssc-clone')) s.setAttribute('aria-hidden', 'true');
      var link = s.querySelector('a[data-ssc-link][href]');
      if (link) link.tabIndex = hidden ? -1 : 0;
    }, this);
    if (instant) {
      void this.track.offsetWidth;   // apply without animating, then hand back the transitions
      this.slides.forEach(function (s) { s.classList.remove('no-anim'); });
    }
  };

  Carousel.prototype.logical = function (i) { return i % this.count; };

  Carousel.prototype.show = function (i, quiet) {
    var k = this.logical(i);
    this.bgs.forEach(function (b, j) { b.classList.toggle('is-on', j === k); });
    this.updateCta();
    if (!quiet) this.announce();
  };

  // the button follows the middle watch and the chosen band; hidden when that watch has nowhere to go
  Carousel.prototype.updateCta = function () {
    if (!this.cta || !this.slides) return;
    var s = this.slides[this.cur];
    var url = s.getAttribute('data-url-' + this.band) || '';
    var name = (s.querySelector('.ssc__name') || {}).textContent || '';
    if (url) this.cta.setAttribute('href', url); else this.cta.removeAttribute('href');
    this.cta.classList.toggle('is-off', !url);
    var label = (this.cta.querySelector('[data-ssc-cta-label]') || this.cta).textContent.trim();
    this.cta.setAttribute('aria-label', label + ': ' + name + ', ' + this.band);
  };

  Carousel.prototype.announce = function () {
    var s = this.slides[this.cur];
    var name = (s.querySelector('.ssc__name') || {}).textContent || '';
    var price = (s.querySelector('[data-band-price="' + this.band + '"]') || {}).textContent || '';
    if (this.live) this.live.textContent = name + ', ' + (this.logical(this.cur) + 1) + ' of ' + this.count + (price ? ', ' + price : '');
  };

  Carousel.prototype.go = function (dir, opts) {
    opts = opts || {};
    if (this.count < 2 || !dir) return;
    if (this.busy) { if (this.queue.length < 2) this.queue.push(dir); return; }
    this.busy = true;
    var self = this, reduce = this.reduce.matches;
    var old = this.slides[this.cur];
    var next = (this.cur + dir + this.n) % this.n;
    var far = Math.floor(this.n / 2);

    // the card that will come in must wait just beyond the side it comes from
    this.slides.forEach(function (s, i) {
      var p = this.pos[i];
      if (Math.abs(p) === far && this.n % 2 === 0 && Math.sign(p) !== dir) {
        this.pos[i] = -p;
        s.classList.add('no-anim');
        s.style.setProperty('--off', -p);
      }
    }, this);
    void this.track.offsetWidth;
    this.slides.forEach(function (s) { s.classList.remove('no-anim'); });

    old.classList.remove('is-shown');
    var lead = (reduce || opts.fromDrag) ? 0 : TEXT_OUT;

    this.later(function () {
      self.cur = next;
      self.pos = self.pos.map(function (p) {
        var q = p - dir;
        return Math.abs(q) > far ? q - Math.sign(q) * self.n : q;
      });
      self.place(false);
      self.show(next);
      if (!reduce) self.lean(dir);
    }, lead);

    var glide = reduce ? 0 : GLIDE;
    this.later(function () { self.slides[next].classList.add('is-shown'); }, lead + Math.max(0, glide - TEXT_IN_EARLY));
    this.later(function () {
      self.busy = false;
      if (self.queue.length) self.go(self.queue.shift());
    }, lead + glide);
  };

  // while gliding, each visible watch runs a little ahead of its card, then settles
  Carousel.prototype.lean = function (dir) {
    if (!Element.prototype.animate) return;
    this.slides.forEach(function (s, i) {
      if (Math.abs(this.pos[i]) > 1 && Math.abs(this.pos[i] + dir) > 1) return;
      var f = s.querySelector('.ssc__float');
      if (!f) return;
      f.animate([
        { transform: 'translateX(0) rotate(0deg)' },
        { transform: 'translateX(' + (-dir * 7) + '%) rotate(' + (-dir * 2) + 'deg)', offset: 0.42 },
        { transform: 'translateX(0) rotate(0deg)' }
      ], { duration: GLIDE + 150, easing: 'cubic-bezier(.45,0,.2,1)' });
    }, this);
  };

  Carousel.prototype.goTo = function (logicalIndex) {
    if (this.count < 2) return;
    var here = this.logical(this.cur);
    var d = logicalIndex - here;
    if (!d) return;
    if (d > this.count / 2) d -= this.count;
    if (d < -this.count / 2) d += this.count;
    var step = d > 0 ? 1 : -1;
    for (var k = 0; k < Math.abs(d); k++) this.go(step);
  };

  Carousel.prototype.setBand = function (band, quiet) {
    this.band = band;
    this.root.setAttribute('data-band', band);
    [].forEach.call(this.root.querySelectorAll('[data-ssc-band]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ssc-band') === band ? 'true' : 'false');
    });
    this.slides.forEach(function (s) {
      var url = s.getAttribute('data-url-' + band);
      var a = s.querySelector('[data-ssc-link]');
      if (a && url) a.setAttribute('href', url);
    });
    this.updateCta();
    if (!quiet) this.announce();
  };

  Carousel.prototype.stopAuto = function () { this.autoStopped = true; clearTimeout(this.autoTimer); };

  Carousel.prototype.bindControls = function () {
    var self = this, root = this.root;
    var prev = root.querySelector('[data-ssc-prev]'), next = root.querySelector('[data-ssc-next]');
    if (prev) prev.addEventListener('click', function () { self.stopAuto(); self.go(-1); });
    if (next) next.addEventListener('click', function () { self.stopAuto(); self.go(1); });
    [].forEach.call(root.querySelectorAll('[data-ssc-band]'), function (b) {
      b.addEventListener('click', function () { self.stopAuto(); self.setBand(b.getAttribute('data-ssc-band')); });
    });
    // a click on a peeking card brings it to the middle instead of following its link
    this.track.addEventListener('click', function (e) {
      if (self.dragged) { e.preventDefault(); self.dragged = false; return; }
      var s = e.target.closest('[data-ssc-slide]');
      if (!s) return;
      var p = self.pos[self.slides.indexOf(s)];
      if (p !== 0) { e.preventDefault(); self.stopAuto(); self.go(p > 0 ? 1 : -1); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.stopAuto(); self.go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.stopAuto(); self.go(1); }
    });
  };

  Carousel.prototype.bindDrag = function () {
    var self = this, stage = this.stage, root = this.root;
    var start = null, dx = 0, dy = 0, id = null, locked = null;
    stage.addEventListener('pointerdown', function (e) {
      if (self.count < 2 || e.button !== 0 || self.busy) return;
      start = { x: e.clientX, y: e.clientY }; dx = dy = 0; id = e.pointerId; locked = null;
      self.dragged = false;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!start || e.pointerId !== id) return;
      dx = e.clientX - start.x; dy = e.clientY - start.y;
      if (locked === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (locked === 'x') {
          root.classList.add('is-dragging');
          try { stage.setPointerCapture(id); } catch (err) {}
        }
      }
      if (locked !== 'x') return;
      self.dragged = true;
      var w = stage.clientWidth, resist = dx / (1 + Math.abs(dx) / (w * 0.6));
      self.slides.forEach(function (s) { s.style.setProperty('--drag', resist + 'px'); });
    });
    function end(e) {
      if (!start || (e && e.pointerId !== id)) return;
      var wasX = locked === 'x';
      start = null; locked = null;
      root.classList.remove('is-dragging');
      self.slides.forEach(function (s) { s.style.setProperty('--drag', '0px'); });
      if (!wasX) return;
      var far = Math.abs(dx) > Math.min(90, stage.clientWidth * 0.12);
      if (far) { self.stopAuto(); self.go(dx < 0 ? 1 : -1, { fromDrag: true }); }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    // only the stage's own capture ending counts: on touch, moving capture to the stage
    // makes the touched element fire one too, and that one bubbles up here
    stage.addEventListener('lostpointercapture', function (e) { if (e.target === stage) end(e); });
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  // a soft dot that trails the mouse, as in the reference video (mouse only)
  Carousel.prototype.bindCursor = function () {
    var root = this.root, dot = this.cursor;
    if (!dot || root.getAttribute('data-cursor') === 'off') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.classList.add('cursor-dot');
    var x = 0, y = 0, tx = 0, ty = 0, raf = 0, on = false;
    function step() {
      x += (tx - x) * 0.22; y += (ty - y) * 0.22;
      dot.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      raf = (Math.abs(tx - x) + Math.abs(ty - y) > 0.3) ? requestAnimationFrame(step) : 0;
    }
    root.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = root.getBoundingClientRect();
      tx = e.clientX - r.left; ty = e.clientY - r.top;
      if (!on) { x = tx; y = ty; on = true; root.classList.add('has-cursor'); }
      var t = e.target;
      root.classList.toggle('is-pointing', !!(t.closest && t.closest('a, button')));
      if (!raf) raf = requestAnimationFrame(step);
    });
    root.addEventListener('pointerleave', function () { on = false; root.classList.remove('has-cursor', 'is-pointing'); });
  };

  Carousel.prototype.bindAutoplay = function () {
    var self = this, root = this.root;
    var secs = parseFloat(root.getAttribute('data-autoplay')) || 0;
    if (secs <= 0 || this.count < 2) return;
    var hover = false, focus = false, seen = true;
    function arm() {
      clearTimeout(self.autoTimer);
      if (self.autoStopped || self.reduce.matches) return;
      self.autoTimer = setTimeout(function () {
        if (hover || focus || !seen || document.hidden) return arm();
        self.go(1); arm();
      }, secs * 1000);
    }
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    root.addEventListener('pointerleave', function () { hover = false; });
    root.addEventListener('focusin', function () { focus = true; });
    root.addEventListener('focusout', function () { focus = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0.35 }).observe(root);
    }
    arm();
  };

  Carousel.prototype.destroy = function () {
    this.timers.forEach(clearTimeout);
    clearTimeout(this.autoTimer);
  };

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-ssc]'), function (el) {
      if (!el.__ssc) el.__ssc = new Carousel(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Shopify theme editor: rebuild when the section is edited, and show the block being edited
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-ssc]'), function (el) { if (el.__ssc && el.__ssc.destroy) el.__ssc.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-ssc]');
    if (!root || !root.__ssc || !root.__ssc.slides) return;
    var c = root.__ssc, i = c.slides.indexOf(e.target.closest('[data-ssc-slide]'));
    if (i >= 0) { c.stopAuto(); c.goTo(c.logical(i)); }
  });

  window.StrangeStoneCarousel = { init: initAll };
})();
